import Layer from '@arcgis/core/layers/Layer';
import { GISService } from '../gisServicesTypes';
import { ensureLoadedLayerArray, LayerLoader } from './LayerLoader';

/**
 * Load a layer that's not otherwise special
 */
export const defaultLayerLoader: LayerLoader = {
  shouldUseLoader() {
    return true;
  },
  async load(service) {
    const url = service.gis_service_url?.toLowerCase() || '';
    const isEPRCLayer = url.includes('nenaeprc');
    const isGeocommLayer = url.includes('geocomm') && !isEPRCLayer;

    const properties: __esri.LayerFromArcGISServerUrlParams['properties'] = {
      id: service.gisLayerID,
      visible: service.auto_checked || false,
      outFields: ['*'],
    };

    // Apply 40% opacity to non-geocomm layers (supplemental layers like traffic, weather)
    // Geocomm layers (ECC-specific) get full opacity
    if (!isGeocommLayer) {
      properties.opacity = 0.4;
    }
    // Geocomm to handle this
    // if (isEPRCLayer) {
    //   properties.opacity = 0.3; //opacity for EPRC layers (little more faded than other layers)
    // }

    return loadWithProperties(service, properties);
  },
};

// This pattern gets reused with different properties for several layer types:
export async function loadWithProperties(
  service: GISService,
  properties: __esri.LayerFromArcGISServerUrlParams['properties'],
) {
  const apiKey = service.token;
  const url = service.gis_service_url;
  const requestUrl = apiKey ? url + `?token=${apiKey}` : url;
  const layer = await Layer.fromArcGISServerUrl({
    url: requestUrl,
    properties: {
      apiKey,
      ...properties,
    },
  });
  await layer.load();

  return ensureLoadedLayerArray(layer);
}
